import {ErrorHandler, Injectable, NgZone} from '@angular/core';
import {environment} from '../environments/environment';
import {ErrorService} from './error/error.service';

@Injectable({
    providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {

    constructor(private readonly ngZone: NgZone, private readonly errorService: ErrorService) {
    }

    public handleError(error): void {
        if (!environment.production) {
            console.error(error);
        }
        this.ngZone.run(() => {
            this.errorService.navigateToErrorPage(error.rejection);
        });
    }
}
